import React from 'react';
import Table from '../../components/common/Table';

interface LeadTableProps {
  data: any[];
  handleEdit: (service: any) => void;
  handleDelete: (service: any) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const LeadTable: React.FC<LeadTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Project Type',
          key: 'projectTypeName',
        },
        {
          label: 'Rep',
          key: 'createdByName',
        },
        {
          label: 'First Name',
          key: 'firstName',
        },
        {
          label: 'Last Name',
          key: 'lastName',
        },
        {
          label: 'Company Name',
          key: 'companyName',
        },
        {
          label: 'Email',
          key: 'email',
        },
        {
          label: 'Phone Number',
          key: 'phoneNumber',
        },
        {
          label: 'Address',
          key: 'address',
        },
        {
          label: 'Last Note',
          key: 'lastNote',
        }
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default LeadTable;
